import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { references } from '../services/references.service';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';

export const autorizedGuard: CanActivateFn = (route, state) => {


  if (typeof sessionStorage === 'undefined') {
    return false;
  }

  // Valida existencia do token
  if (localStorage.getItem(references._STORAGE_TOKEN)) {
    inject(AuthService).logOut();

    inject(Router).navigateByUrl('login');
    return false;
  } else {
    return true;
  }
};
